// extracted by mini-css-extract-plugin
module.exports = {"authorTokens":"author_authorTokens__vD85I","onDark":"author_onDark__k1_fP","author":"author_author__4giE2"};